<template>
  <div>
    <v-app-bar color="primary" flat>
      <v-spacer></v-spacer>
      <img
        :src="`${publicPath}img/logo-white-small.png`"
        style="max-height: 26px; height: 100%"
      />
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container class="pt-6 pb-10">
      <div v-if="showConsent">
        <consent @nextStep="showConsent = false" />
      </div>
      <div v-else>
        <h3 class="mb-4 text-center font-weight-bold" style="color: #c6291e">
          ส่งเอกสารเคลมเพิ่มเติม
        </h3>
        <v-divider></v-divider>
        <div class="d-flex justify-center py-6">
          <img
            :src="`${publicPath}img/claim_banner.png`"
            style="width: 100%; height: auto; max-width: 576px"
          />
        </div>

        <v-tabs
          v-model="tab"
          active-class="primary"
          background-color="#CA8383"
          class="custom-tab"
          color="#FFF"
          dark
          grow
          height="56px"
          hide-slider
        >
          <v-tab
            v-for="item in tabItems"
            :key="item"
            :href="`#tab-${item}`"
            class="px-2"
            style="width: 50%"
          >
            <div v-if="item === 'new'" style="font-size: 12px !important">
              <div>ยื่นเคลมใหม่</div>
              <div>New Claim</div>
            </div>
            <div
              v-if="item === 'additional'"
              style="font-size: 12px !important"
            >
              <div>ยื่นเอกสารเคลมเพิ่มเติม</div>
              <div>Additional Document</div>
            </div>
          </v-tab>
        </v-tabs>

        <div class="mt-9">
          <v-tabs-items v-model="tab" style="background: transparent">
            <v-tab-item :key="'tab-new'" :value="'tab-new'">
              <NewSubmissionForm
                :loading="isLoading"
                :resetForm="isResetForm"
                @onSubmit="handleSubmitForm"
              />
            </v-tab-item>
            <v-tab-item :key="'tab-additional'" :value="'tab-additional'">
              <AdditionalForm
                :loading="isLoading"
                :resetForm="isResetForm"
                @onSubmit="handleSubmitForm"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import NewSubmissionForm from "@/components/ClaimForm/NewSubmissionForm.vue";
import axios from "axios";
import AdditionalForm from "../components/ClaimForm/AdditionalForm.vue";
import Consent from "../components/ClaimForm/Consent.vue";

export default {
  components: {
    NewSubmissionForm,
    AdditionalForm,
    Consent,
  },
  data() {
    return {
      showConsent: true,
      tab: "tab-additional",
      tabItems: ["additional"], //["new", "additional"],
      isResetForm: new Date(),
      isLoading: false,
    };
  },
  computed: {
    publicPath() {
      return process.env.BASE_URL;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  watch: {
    tab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isResetForm = new Date();
      }
    },
  },
  methods: {
    async handleSubmitForm(payload) {
      const vm = this;
      try {
        const apiUrl = this.$store.state.serverUrl;
        const apiToken = this.$store.state.apiToken;
        const apiKey = this.$store.state.serverApiKey;
        const zwizPageToken = this.$store.state.zwizPageToken;

        const url = `${apiUrl}api/generali/claim-form`;

        const { form_type, ...rest } = payload;
        const data = {
          page_id: vm.query.pageid,
          form_type: form_type,
          fields: {
            ...rest,
          },
          user_id: vm.profile.userId + "__" + vm.query.pageid,
          page_token: zwizPageToken,
        };

        vm.isLoading = true;

        const response = await axios.post(url, data, {
          headers: {
            AUTHORIZATION: `Bearer ${apiToken}`,
            "x-api-key": apiKey,
          },
        });

        vm.isLoading = false;

        if (response && response.status === 204) {
          await vm.$swal
            .fire({
              icon: "success",
              confirmButtonColor: "#c5281d",
              html: `บันทึกการยื่นเคลม / ส่งเอกสารเคลมเพิ่มเติมเรียบร้อย<br/>ทีมเคลมจะตรวจสอบภายใน 5 วันทำการ ขอบคุณค่ะ`,
            })
            .then(() => {
              if (typeof vm.$liff !== "undefined") {
                vm.$liff.closeWindow();
              } else {
                window.close();
              }
              vm.isResetForm = new Date();
            });
        } else {
          await vm.$swal.fire({
            icon: "error",
            text: response.data.reason,
          });
        }
      } catch (error) {
        console.error(error);
        if (error.data && error.data.message) {
          await vm.$swal.fire({
            icon: "error",
            text: error.data.message,
          });
        }
      } finally {
        vm.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tab {
  .v-tab {
    letter-spacing: 0.5px !important;
  }

  .v-tab--active::before {
    opacity: 0 !important;
  }
}
</style>
